import {IRange} from "@pg-design/inputs-module";

import {isDevelopment} from "../../../app/read_rp_environment_variables";
import {OfferType} from "../../../offer/types/OfferType";
import {Currency} from "../../../types/Currency";
import {ISearchFilter} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";
import {FilterMultiCheckbox} from "./FilterMultiCheckbox";
import {FilterOfferType} from "./FilterOfferType";
import {FilterRadioCheckbox} from "./FilterRadioCheckbox";
import {FilterRange} from "./FilterRange";
import {FilterSelectRange} from "./FilterSelectRange";

interface IProps<TFilterValue, TValue> extends ILegacyFieldProps<TValue> {
    filter: ISearchFilter<string, TFilterValue>;
    currency?: Currency;
    isInModal?: boolean;
}

interface ILegacyFieldProps<TValue> {
    value: TValue;
    onChange: (name: string, value: TValue) => void;
    onAfterChange?: (name: string, value: TValue) => void;
}

export const RealEstateLegacyFilter = <TFilterValue, TValue>(props: IProps<TFilterValue, TValue>) => {
    if (isMultiCheckboxFilter(props)) {
        let value = props.value ? props.value : [];
        if (props.value && !Array.isArray(props.value)) {
            value = [...props.value];
        }
        return <FilterMultiCheckbox filter={props.filter} value={value} onChange={props.onChange} />;
    }

    if (isOfferTypeFilter(props)) {
        // Typ nieruchomości
        return <FilterOfferType filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isRangeCheckBoxFilter(props)) {
        return <FilterSelectRange filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isRangeFilter(props)) {
        return <FilterRange filter={props.filter} value={props.value} onChange={props.onChange} currency={!!props.currency} />;
    }

    if (isRadioCheckboxFilter(props)) {
        return <FilterRadioCheckbox filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isDevelopment) {
        throw new Error(`Unknown filter configuration passed to 'GenericFilter' - check filters configuration for: ` + props.filter.id);
    }

    return null;
};

const isMultiCheckboxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<string | number, (string | number)[]> => {
    return props?.filter?.type === SearchFilterTypes.MULTI_CHECKBOX;
};

const isOfferTypeFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<OfferType, OfferType[]> => {
    return props.filter.type === SearchFilterTypes.OFFER_TYPE;
};

const isRangeCheckBoxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<number | "">> => {
    return props.filter.type === SearchFilterTypes.SELECT_RANGE;
};

const isRangeFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<string>> => {
    return props.filter.type === SearchFilterTypes.RANGE;
};

const isRadioCheckboxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<string | number, (string | number)[]> => {
    return props.filter.type === SearchFilterTypes.RADIO;
};
import {IRange} from "@pg-design/inputs-module";

import {isDevelopment} from "../../../app/read_rp_environment_variables";
import {OfferType} from "../../../offer/types/OfferType";
import {Currency} from "../../../types/Currency";
import {ISearchFilter} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";
import {FilterMultiCheckbox} from "./FilterMultiCheckbox";
import {FilterOfferType} from "./FilterOfferType";
import {FilterRadioCheckbox} from "./FilterRadioCheckbox";
import {FilterRange} from "./FilterRange";
import {FilterSelectRange} from "./FilterSelectRange";

interface IProps<TFilterValue, TValue> extends ILegacyFieldProps<TValue> {
    filter: ISearchFilter<string, TFilterValue>;
    currency?: Currency;
    isInModal?: boolean;
}

interface ILegacyFieldProps<TValue> {
    value: TValue;
    onChange: (name: string, value: TValue) => void;
    onAfterChange?: (name: string, value: TValue) => void;
}

export const RealEstateLegacyFilter = <TFilterValue, TValue>(props: IProps<TFilterValue, TValue>) => {
    if (isMultiCheckboxFilter(props)) {
        let value = props.value ? props.value : [];
        if (props.value && !Array.isArray(props.value)) {
            value = [...props.value];
        }
        return <FilterMultiCheckbox filter={props.filter} value={value} onChange={props.onChange} />;
    }

    if (isOfferTypeFilter(props)) {
        // Typ nieruchomości
        return <FilterOfferType filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isRangeCheckBoxFilter(props)) {
        return <FilterSelectRange filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isRangeFilter(props)) {
        return <FilterRange filter={props.filter} value={props.value} onChange={props.onChange} currency={!!props.currency} />;
    }

    if (isRadioCheckboxFilter(props)) {
        return <FilterRadioCheckbox filter={props.filter} value={props.value} onChange={props.onChange} />;
    }

    if (isDevelopment) {
        throw new Error(`Unknown filter configuration passed to 'GenericFilter' - check filters configuration for: ` + props.filter.id);
    }

    return null;
};

const isMultiCheckboxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<string | number, (string | number)[]> => {
    return props?.filter?.type === SearchFilterTypes.MULTI_CHECKBOX;
};

const isOfferTypeFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<OfferType, OfferType[]> => {
    return props.filter.type === SearchFilterTypes.OFFER_TYPE;
};

const isRangeCheckBoxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<number | "">> => {
    return props.filter.type === SearchFilterTypes.SELECT_RANGE;
};

const isRangeFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<number, IRange<string>> => {
    return props.filter.type === SearchFilterTypes.RANGE;
};

const isRadioCheckboxFilter = (props: {filter: {type: SearchFilterTypes}}): props is IProps<string | number, (string | number)[]> => {
    return props.filter.type === SearchFilterTypes.RADIO;
};
